import { movies } from '@/mocks/movies';
import MovieCard from '@/components/base/MovieCard';
import SectionTitle from '@/components/base/SectionTitle';

export default function FeaturedMovies() {
  const latest = [...movies].sort((a, b) => b.year - a.year || b.rating - a.rating).slice(0, 8);

  return (
    <section className="mt-14">
      <SectionTitle
        eyebrow="Latest Releases"
        icon="ri-film-line"
        title="精选最新电影"
        description="从近年上映的韩国剧情片中，挑选值得细读的作品，附导演与简介速览。"
        moreTo="/category"
        moreLabel="进入分类列表"
      />
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-5">
        {latest.map((m) => (
          <MovieCard key={m.id} movie={m} />
        ))}
      </div>
    </section>
  );
}